import { Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import { Helmet } from "react-helmet-async";

const SitePolicies = () => {
  return (
    <>
      <Helmet>
        <title>Políticas del Sitio | Centro Médico MEDAM</title>

        <meta
          name="description"
          content="Consulta las políticas del sitio web del Centro Médico MEDAM. Conoce nuestras políticas de privacidad, uso de cookies, cancelación y reprogramación de citas, uso aceptable del sitio y canales de contacto."
        />

        <meta
          name="keywords"
          content="políticas del sitio, políticas de privacidad, cookies, Centro Médico MEDAM, cancelación de citas, reprogramación, uso aceptable, protección de datos, Estado de México"
        />

        <meta
          property="og:title"
          content="Políticas del Sitio | Centro Médico MEDAM"
        />

        <meta
          property="og:description"
          content="Infórmate sobre las políticas del sitio web del Centro Médico MEDAM, incluyendo privacidad, cookies, cancelaciones, uso aceptable y protección de datos."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://centromedicomedam.com/politicas-del-sitio"
        />

        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />

        <meta property="og:site_name" content="Centro Médico MEDAM" />

        <meta property="og:locale" content="es_MX" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Políticas del Sitio | Centro Médico MEDAM"
        />

        <meta
          name="twitter:description"
          content="Consulta las políticas oficiales del sitio web del Centro Médico MEDAM sobre privacidad, cookies, citas y uso del portal."
        />

        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href="https://centromedicomedam.com/politicas-del-sitio"
        />
      </Helmet>
      <Grid container width="100%" sx={design.BackGroud}>
        <Grid size={design.Grid1} />
        <Grid container size={design.Grid10} pt={3}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Contacto para médicos"
            sx={design.Titulo}
          >
            Políticas del sitio
          </CustomText>
          <Grid container width="100%" pb={5}>
            <Grid size={design.Grid2} />
            <Grid size={design.Grid8}>
              <CustomText
                variant="subtitle1"
                color="#333333"
                text="Eres medico y quieres"
                sx={design.Description}
              >
                <strong>1. Política de privacidad y confidencialidad</strong>{" "}
                Respetamos tu privacidad. Toda información personal que
                recolectamos es tratada con confidencialidad conforme al Aviso
                de Privacidad vigente, en cumplimiento con la Ley Federal de
                Protección de Datos Personales en Posesión de los Particulares.
                <br />
                <br />
                <strong>
                  2. Política de cookies y tecnologías similares
                </strong>{" "}
                Este sitio puede utilizar cookies propias o de terceros para
                fines analíticos y de mejora de experiencia de usuario (por
                ejemplo, Google Analytics). Al navegar por el sitio, aceptas su
                uso. Puedes deshabilitarlas en la configuración de tu navegador.
                <br />
                <br />
                <strong>
                  3. Política de cancelación y reprogramación de citas
                </strong>{" "}
                En caso de requerir la cancelación o cambio de una cita o
                procedimiento, solicitamos notificar con al menos 24 horas de
                anticipación. En algunas circunstancias podrá aplicarse una
                tarifa por cancelación tardía o inasistencia sin previo aviso.
                <br />
                <br />
                <strong>4. Política de uso aceptable</strong> Está prohibido el
                uso del Sitio para distribuir contenido ofensivo, fraudulento o
                dañino. Nos reservamos el derecho de restringir el acceso a
                usuarios que incumplan esta política.
                <br />
                <br />
                <strong>5. Contacto</strong> Para dudas, aclaraciones o
                ejercicio de tus{" "}
                <a
                  href="https://centromedicomedam.com/IMG/centromedicoMEDAM/Solicitud_de_Derechos_ARCO.pdf"
                  download
                  style={{
                    color: "inherit",
                    textDecoration: "underline",
                    fontWeight: 700,
                  }}
                >
                  derechos ARCO
                </a>
                , puedes contactarnos a través del formulario disponible en el
                sitio o en nuestras instalaciones en el Estado de México.
              </CustomText>
            </Grid>
            <Grid size={design.Grid2} />
          </Grid>
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
    </>
  );
};
export default SitePolicies;

const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  Titulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    lineHeight: "normal",
    textAlign: "center",
    paddingTop: 2,
    width: "100%",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "justify",
    width: "100%",
    marginTop: 2,
  },
  Grid1: { xs: 0.5, md: 1, xl: 1, lg: 1 },
  Grid2: { xs: 0.5, md: 3, xl: 3, lg: 3 },
  Grid8: { xs: 11, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 11, md: 10, xl: 10, lg: 10 },
};
